// extenciones de dominio de emails que no son validas.
export const NOT_VALID_EXTENTIONS = ['gmail', 'hotmail'];
// URL de la api de mapas
export const GOOGLE_API_KEY = 'AIzaSyCm0oUVMj2uZFa7EAhn-TzSEJV31dyxMEg'
export const GOOGLE_MAPS_URL = `https://maps.google.com/maps/api/js?key=`+GOOGLE_API_KEY;